export class BildirimEntity{
    id!: number;
    baslik!: string;
    aciklama!: string;
    okundu_mu!: boolean;
    user_id!: number;
    takip_id!:number;
    takip_durumu!:string;
    is_id!:number;
}